import Vue from 'vue'
import VueRouter from 'vue-router'
import Element from 'element-ui'
import VueI18n from 'vue-i18n'

import VueMoment from 'vue-moment'

// Validation plugin used to validate forms
import VeeValidate from 'vee-validate'
import attributesFr from 'vee-validate/dist/locale/fr.js'
import attributesEn from 'vee-validate/dist/locale/en.js'
import locale from 'element-ui/lib/locale/lang/fr'
import App from './App.vue'
import store from './store.js'
import router from './routes/router'

// Axios
import axios from 'axios'
Vue.prototype.$axios = axios
import './axios-interceptors-refresh-token.js'

// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'

// library imports
import './assets/sass/paper-dashboard.scss'
import './assets/sass/demo.scss'

import sidebarLinks from './sidebarLinks'

// Font awesome
import 'font-awesome/css/font-awesome.css'

const codeLanguePrincipale = navigator.language
let langue = 'fr'
switch (codeLanguePrincipale) {
  case 'fr-FR':
    langue = 'fr'
    break
  case 'en-US':
  case 'en-GB':
    langue = 'en'
    break
}

// plugin setup
Vue.use(VueRouter)
Vue.use(VueI18n)
Vue.use(Element, { locale })
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(SideBar, { sidebarLinks: sidebarLinks })
Vue.use(VueMoment)

const i18n = new VueI18n({ locale: langue })
Vue.use(VeeValidate, {
  i18nRootKey: 'validations',
  i18n,
  dictionary: {
    en: attributesEn,
    fr: attributesFr,
  },
  events: '',
})

// Outil sur les valeurs
import ValueUtils from './util/ValueUtils'
Object.defineProperty(Vue.prototype, '$val', { value: ValueUtils })

//gestion des evenements
import EventBus from './eventBus.js'
Vue.prototype.$eventHub = EventBus

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
  i18n,
})
